import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Select, { SingleValue } from 'react-select';
import { getUserPreferenceUIConfig } from 'shared-utils';
import { useGetAllHiringAssessments } from 'src/hooks/hiringAssessment.hooks';

const HiringAssessmentCandidatesHeader = ({ onClick }: { onClick?: (id: string) => void }) => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { data: allHiringAssessments } = useGetAllHiringAssessments();

	const assessmentsOptions = allHiringAssessments?.hiringAssessmentList?.map(assessment => ({
		label: getUserPreferenceUIConfig({
			text: assessment?.userPreferenceSnapshot?.careerPath || '',
		})?.finalText as string,
		value: assessment?._id,
	}));

	return (
		<div className="flex gap-2 flex-wrap justify-between md:justify-start items-center py-2 pt-6 sm:pt-[10px]">
			<div className="text-base md:text-xl font-semibold text-[#1C1C28] dark:text-white">Assessed Candidates</div>

			<div className="whiteBgSelect">
				<Select
					className="w-full md:w-[306px] !font-[400] !text-[16px]"
					menuPlacement={'auto'}
					classNamePrefix="my-select-plans"
					closeMenuOnSelect
					options={assessmentsOptions}
					value={assessmentsOptions?.find(o => o.value === id)}
					onChange={(
						val: SingleValue<{
							label: string;
							value: string;
						}>,
					) => {
						if (onClick && val?.value) {
							onClick(val?.value);
						} else if (val?.value) {
							navigate(`/recruiter-dashboard/hiring-assessment-list/${val.value}`);
						}
					}}
				/>
			</div>
		</div>
	);
};

export default HiringAssessmentCandidatesHeader;
